<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="权限名称 " prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入权限名称"></Input>
				</FormItem>
				<!-- <FormItem label="权限字符串" prop="privilege" class="sj">
					<Input v-model="formValidate.privilege" placeholder="请输入权限字符串"></Input>
				</FormItem> -->
				<FormItem label="访问链接" prop="url" class="sj">
					<Input v-model="formValidate.url" placeholder="请输入访问链接"></Input>
				</FormItem>
				<FormItem label="是否需要登陆"  class="sj" prop="noNeedLogin">
					<Select v-model="formValidate.noNeedLogin" placeholder="请选择">
						<Option value="true">需要</Option>
						<Option value="false">不需要</Option>
					</Select>
				</FormItem>
				<FormItem label="权限类型"  class="sj" prop="menuType">
					<Select v-model="formValidate.menuType" placeholder="请选择类型">
						<Option value="JM">捷米</Option>
						<Option value="ALLIANCE">加盟商</Option>
						<Option value="OPER">运营商</Option>
						<Option value="CLIENT">公共</Option>
						<Option value="COMM">加盟商</Option>
					</Select>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					name: '',
					url:"",
					privilege:'',
					noNeedLogin:'true',
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '权限名称不能为空！！！',
						trigger: 'blur'
					}],
					url: [{
						required: true,
						message: '请求链接不能为空！！！',
						trigger: 'blur'
					}],
					privilege: [{
						required: true,
						message: '权限字符菜不能为空！！！',
						trigger: 'blur'
					}],
					noNeedLogin: [{
						required: true,
						message: '是否必须登录访问不能为空！！！',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '密码不能为空！！！',
						trigger: 'blur'
					}],
					
					menuType: [{
						required: true,
						message: '权限类型不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			setRegion(regionId){
				this.formValidate.regionId=regionId
			},
			handleSubmit(name) {
				let _this=this
				_this.formValidate.privilege=_this.formValidate.url
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.formValidate.username=this.formValidate.phone
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/menu/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/jurisdiction/menu/add.vue